//import { useDimensionsContext } from '../Chart'
const CurvedArrows = ({ step, direction, dimensions }) => {
  //const dimensions = useDimensionsContext()

  const isSmall = dimensions.height < 420
  const isNarrow = dimensions.width < 560

  return (
    <svg>
      <g
        transform={`translate(${isNarrow ? 10 : 120},${
          (2 * dimensions.boundedHeight) / 3 + (isSmall ? 30 : -10)
        })`}
      >
        <path
          className={`arrow animated step-${step} ${direction} arrow-1`}
          d={`M0,0 C${dimensions.boundedWidth / 2},0 ${
            (2 * dimensions.boundedWidth) / 3.25
          },0 ${(2 * dimensions.boundedWidth) / 3.25},${
            -dimensions.boundedHeight / 12
          }`}
        />
        <g
          transform={`translate(${
            (2 * dimensions.boundedWidth) / 3.25 - 10
          },  ${-dimensions.boundedHeight / 12 - 3})`}
        >
          <line
            className={`arrow-head step-${step} ${direction}`}
            x1={10}
            y1={0}
            x2={3}
            y2={7}
          />
          <line
            className={`arrow-head step-${step} ${direction}`}
            x1={10}
            y1={0}
            x2={17}
            y2={7}
          />
        </g>
        <path
          className={`arrow dashed step-${step} ${direction}`}
          d={`M0,0 C${dimensions.boundedWidth / 2},0 ${
            (2 * dimensions.boundedWidth) / 3.25
          },0 ${(2 * dimensions.boundedWidth) / 3.25},${
            -dimensions.boundedHeight / 12
          }`}
        />
      </g>
      {/* second arrow */}
      <g
        transform={`translate(${
          dimensions.boundedWidth / 3 + (isNarrow ? 10 : 120)
        },${(2 * dimensions.boundedHeight) / 3 + +(isSmall ? 30 : -10)})`}
      >
        <path
          className={`arrow animated step-${step} ${direction} arrow-2`}
          d={`M0,0 C${dimensions.boundedWidth / 4},0 ${
            dimensions.boundedWidth / 3
          },0 ${dimensions.boundedWidth / 3},${-dimensions.boundedHeight / 12}`}
        />
        <path
          className={`arrow dashed step-${step} ${direction}`}
          d={`M0,0 C${dimensions.boundedWidth / 4},0 ${
            dimensions.boundedWidth / 3
          },0 ${dimensions.boundedWidth / 3},${-dimensions.boundedHeight / 12}`}
        />
        <g
          transform={`translate(${dimensions.boundedWidth / 3 - 10},  ${
            -dimensions.boundedHeight / 12 - 3
          })`}
        >
          <line
            className={`arrow-head step-${step} ${direction}`}
            x1={10}
            y1={0}
            x2={3}
            y2={7}
          />
          <line
            className={`arrow-head step-${step} ${direction}`}
            x1={10}
            y1={0}
            x2={17}
            y2={7}
          />
        </g>
      </g>
      {/* third arrow */}
      <g
        transform={`translate(${
          (2 * dimensions.boundedWidth) / 3 + (isNarrow ? 10 : 120)
        },${(2 * dimensions.boundedHeight) / 3 + +(isSmall ? 30 : -10)})`}
      >
        <path
          className={`arrow animated step-${step} ${direction} arrow-3`}
          d={`M0,0 C0,0 ${dimensions.boundedWidth / 17},0 ${
            dimensions.boundedWidth / 18
          },${-dimensions.boundedHeight / 12}`}
        />
        <path
          className={`arrow dashed step-${step} ${direction}`}
          d={`M0,0 C0,0 ${dimensions.boundedWidth / 17},0 ${
            dimensions.boundedWidth / 18
          },${-dimensions.boundedHeight / 12}`}
        />
        <g
          transform={`translate(${dimensions.boundedWidth / 18 - 10},  ${
            -dimensions.boundedHeight / 12 - 3
          })`}
        >
          <line
            className={`arrow-head step-${step} ${direction}`}
            x1={10}
            y1={0}
            x2={3}
            y2={7}
          />
          <line
            className={`arrow-head step-${step} ${direction}`}
            x1={10}
            y1={0}
            x2={17}
            y2={7}
          />
        </g>
      </g>
    </svg>
  )
}

export default CurvedArrows
